import Splide from '@splidejs/splide';

export const PXBenefits = (function() {
	'use strict';

	function init() {
		let slider = document.getElementsByClassName("splide");

		if (slider.length > 0) {

			let splide = new Splide( '.splide', {
				// rewind: true,
				perPage: 3,
				perMove: 1,
				pagination: false,
				breakpoints: {
					768: {
						perPage: 1,
						fixedWidth: '260px',
					},
				}
			});

			splide.mount();

		} // if

	}

	return {
		init: init
	};
})();
